import { useNavigate } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleCards() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    navigate(slug);
    window.scrollTo(0, 0);
  };

  return (
    <section id="articles" className="py-16 md:py-24 bg-background-50" aria-labelledby="articles-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            Latest Resources
          </span>
          <h2 id="articles-heading" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Guides &amp;<br />Resources
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-lg">
            12 in-depth guides covering everything from beginner basics to expert buying strategies
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {articles.map((article) => (
            <article
              key={article.slug}
              className="group bg-background-50 rounded-xl border border-background-200/50 overflow-hidden transition-all duration-300 hover:border-background-300/70 cursor-pointer flex flex-col"
            >
              <div
                onClick={() => handleArticleClick(article.slug)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleArticleClick(article.slug);
                }}
                tabIndex={0}
                role="link"
                aria-label={article.title}
                className="flex flex-col flex-1"
              >
                <div className="relative h-40 md:h-44 overflow-hidden">
                  <img
                    src={article.imageSeq}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2 text-foreground-400 text-xs mb-2">
                    <span>{article.date}</span>
                    <span>&bull;</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-foreground-500 text-xs leading-relaxed line-clamp-2 flex-1">
                    {article.excerpt}
                  </p>
                  <span
                    className="inline-flex items-center gap-1 mt-3 text-primary-600 font-medium text-xs cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleArticleClick(article.slug);
                    }}
                  >
                    Read More
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}